import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Globe, Menu, X } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const currentLang = location.pathname.startsWith('/de') ? 'de' : 'en';
  const langPrefix = currentLang === 'de' ? '/de' : '/en';

  const navigation = {
    en: [
      { name: 'Productions', href: '/en/productions' },
      { name: 'Pricing', href: '/en/pricing' },
      { name: 'Articles', href: '/en/blog' },
      { name: 'Contact', href: '/en/contact' },
    ],
    de: [
      { name: 'Produktionen', href: '/de/productions' },
      { name: 'Preise', href: '/de/pricing' },
      { name: 'Artikel', href: '/de/blog' },
      { name: 'Kontakt', href: '/de/contact' },
    ],
  };

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'de' : 'en';
    const currentPath = location.pathname.replace(/^\/(?:en|de)/, '');
    navigate(`/${newLang}${currentPath || ''}`);
  };

  return (
    <header className="fixed top-0 w-full bg-gray-800 backdrop-blur-sm border-b border-gray-700 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to={langPrefix} className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_podcast-hub-22/artifacts/t4qrt8st_Ein%20Logo%20fu%CC%88r%20die%20Marke%20Podcast%20Zurich%20%20Es%20muss%20urban%20ru%CC%88ber%20kommen-1.png"
              alt="Podcast Zurich"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navigation[currentLang].map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-300 hover:text-white font-medium transition-colors"
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="flex items-center gap-2 text-gray-300 hover:text-white hover:bg-gray-700"
            >
              <Globe className="w-4 h-4" />
              {currentLang === 'en' ? 'DE' : 'EN'}
            </Button>
            <Button
              style={{ backgroundColor: '#ffff31', color: '#000' }}
              className="font-semibold hover:opacity-90"
              onClick={() => window.open('https://koalendar.com/e/podcast-session', 'KoalendarBooking', 'width=700,height=800,scrollbars=yes,resizable=yes')}
            >
              {currentLang === 'en' ? 'Book Now' : 'Jetzt Buchen'}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700 pt-4">
            <div className="flex flex-col gap-4">
              {navigation[currentLang].map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-gray-300 hover:text-white font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleLanguage}
                className="flex items-center gap-2 justify-start text-white hover:text-white hover:bg-gray-700"
              >
                <Globe className="w-4 h-4 text-white" />
                <span className="text-white">{currentLang === 'en' ? 'Deutsch' : 'English'}</span>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;